module.exports = __webpack_public_path__ + "static/media/sample_3-07.e70045d9.jpg";